import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const useStyles = makeStyles(() => ({
  phoneContainer: {
    position: "relative",
    width: "100%",
    height: "368px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "20px",
    overflow: "hidden",
    clipPath: "inset(0)",
  },
  phoneFrame: {
    position: "relative",
    width: "100%",
    maxWidth: "356.775px",
    height: "auto",
    aspectRatio: "356.775 / 737",
    backgroundColor: "#000000",
    borderRadius: "56.112px",
    border: "5.025px solid #292826",
    padding: "10.05px 8.38px",
    boxSizing: "border-box",
    transformOrigin: "top center",
    overflow: "hidden",
  },
  phoneScreen: {
    width: "100%",
    height: "100%",
    backgroundColor: "#FFFFFF",
    borderRadius: "41.037px",
    overflow: "hidden",
    position: "relative",
  },
  statusBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "49.412px",
    padding: "0 13.4px",
    backgroundColor: "transparent",
  },
  statusBarLeft: {
    display: "flex",
    alignItems: "center",
    fontSize: "13.4px",
    fontWeight: 600,
    fontFamily: "SF Pro Text, sans-serif",
    color: "#000000",
    letterSpacing: "-0.32px",
  },
  statusBarRight: {
    display: "flex",
    alignItems: "center",
    gap: "6.7px",
  },
  statusBarIcon: {
    width: "15.075px",
    height: "10.05px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dynamicIsland: {
    position: "absolute",
    top: "8px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "104.687px",
    height: "30.987px",
    backgroundColor: "#000000",
    borderRadius: "100px",
    zIndex: 10,
  },
  navigationHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "7.537px 13.4px",
    backgroundColor: "rgba(249, 249, 249, 0.94)",
    backdropFilter: "blur(8.375px)",
    borderBottom: "0.419px solid rgba(60, 60, 67, 0.36)",
  },
  navLeft: {
    display: "flex",
    alignItems: "center",
    gap: "4.188px",
    padding: "7.537px",
  },
  navBackIcon: {
    width: "15.075px",
    height: "20.1px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  navCenter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4.188px",
    flex: 1,
  },
  navAvatar: {
    width: "41.875px",
    height: "41.875px",
    borderRadius: "83.75px",
    backgroundColor: "#E4E7EC",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  navNameRow: {
    display: "flex",
    alignItems: "center",
    gap: "2.512px",
  },
  navServiceName: {
    fontFamily: "Manrope, sans-serif",
    fontSize: "10px",
    fontWeight: 600,
    lineHeight: "15px",
    color: "#000000",
    letterSpacing: "0.5px",
    whiteSpace: "nowrap",
  },
  navChevron: {
    width: "3.35px",
    height: "5.946px",
  },
  navRight: {
    width: "40px",
    padding: "7.537px",
  },
  messagesContainer: {
    flex: 1,
    overflowY: "auto",
    padding: "13.4px 16.75px",
    backgroundColor: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    gap: "1.675px",
  },
  messageGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6.7px",
    width: "100%",
  },
  messageTimestamp: {
    display: "flex",
    justifyContent: "center",
    padding: "13.4px 0",
  },
  timestampText: {
    fontFamily: "SF Pro Text, sans-serif",
    fontSize: "9.21px",
    lineHeight: "10.887px",
    color: "rgba(60, 60, 67, 0.6)",
    letterSpacing: "0.066px",
  },
  messageBubbleContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    paddingRight: "53.6px",
    position: "relative",
  },
  messageBubble: {
    backgroundColor: "#E9E9EB",
    borderRadius: "18px",
    padding: "5.025px 10.05px",
    maxWidth: "calc(100% - 53.6px)",
    position: "relative",
  },
  messageBubbleTail: {
    position: "absolute",
    bottom: "-0.27px",
    left: "-4.19px",
    width: "13.749px",
    height: "17.02px",
    zIndex: 1,
  },
  messageText: {
    fontFamily: "Manrope, sans-serif",
    color: "#000000",
    letterSpacing: "0.5px",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    margin: 0,
  },
  bottomSection: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "65.325px",
    backgroundColor: "#FFFFFF",
    borderTop: "1px solid rgba(60, 60, 67, 0.36)",
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10.05px",
    padding: "3.35px 7.54px",
    height: "100%",
  },
  inputActions: {
    display: "flex",
    gap: "13.4px",
    alignItems: "center",
  },
  cameraIcon: {
    width: "32.383px",
    height: "24.008px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputField: {
    flex: 1,
    backgroundColor: "#FFFFFF",
    border: "1px solid rgba(60, 60, 67, 0.36)",
    borderRadius: "18px",
    padding: "3.35px 10.05px",
    display: "flex",
    alignItems: "center",
    gap: "3.35px",
    minHeight: "36px",
  },
  inputPlaceholder: {
    flex: 1,
    fontFamily: "SF Pro Text, sans-serif",
    fontSize: "14.24px",
    lineHeight: "18.425px",
    color: "rgba(60, 60, 67, 0.6)",
    letterSpacing: "-0.408px",
  },
  inputSendIcon: {
    width: "23.45px",
    height: "23.45px",
    borderRadius: "100px",
    backgroundColor: "#007AFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  homeIndicator: {
    position: "absolute",
    bottom: "6.7px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "112.225px",
    height: "4.187px",
    backgroundColor: "#000000",
    borderRadius: "100px",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    color: "rgba(60, 60, 67, 0.6)",
    fontFamily: "Manrope, sans-serif",
    fontSize: "14px",
    padding: "40px 20px",
  },
}));

export default useStyles;

